// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import {Link} from 'react-aria-components';
import "./DatabaseList.css"
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout.js";
import {LuCloudy, LuFilter, LuPencil, LuServer, LuTable, LuTrash2} from "react-icons/lu";
import api from "../../utils/api.js";
import DefaultButton from "../../components/Buttons/DefaultButton/DefaultButton.js";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal.js";
import {Navigate} from "react-router-dom";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout.js";
import InfoIcon from "../../components/InfoIcon/InfoIcon.js";
import Notification from "../../components/Notification/Notification.js";

function DatabaseList() {
    const [databases, setDatabases] = React.useState(null)
    const [redirect, setRedirect] = React.useState(null)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false)
    const [DatabaseToDelete, setDatabaseToDelete] = React.useState(null)

    function deleteDatabase() {
        api.deleteDatabase(DatabaseToDelete.id).then(() => {
            api.listDatabases().then(data => {
                setDatabases(data)
            })
        })
        setShowDeleteConfirmation(false)
        setDatabaseToDelete(null)
    }

    function onCancelDelete() {
        setShowDeleteConfirmation(false)
        setDatabaseToDelete(null)
    }

    useEffect(() => {
        api.listDatabases().then(data => {
            setDatabases(data)
        })
    }, []);


    if (databases === null || databases === undefined) {
        return <LoadingLayout />
    }
    if (redirect!==null) {
        return <Navigate to={redirect} />
    }

    let content = null;
    if (databases.length === 0) {
        content = <Notification>No Databases have been created yet. Get started by clicking the Define Database button above</Notification>
    } else {
        const rows = databases.map((db) => {
            const icons = []

            if (db.hostingMode === "cloud") {
                icons.push(<InfoIcon key={"cloud"+db.id} infoText="Cloud-Hosted Proxy Instance" icon={<LuCloudy/>}/>)
            } else {
                icons.push(<InfoIcon key={"self"+db.id} infoText="Self-Hosted Proxy Instance" icon={<LuServer/>}/>)
            }

            if (db.tablesCount > 0) {
            icons.push(<InfoIcon  key={"tables"+db.id} infoText={`${db.tablesCount} Tables in the Database`} count={db.tablesCount} icon={<LuTable />}/>)
            }

            if (db.filtersCount > 0) {
                icons.push(<InfoIcon key={"filters"+db.id} infoText={`${db.filtersCount} Filter${db.filtersCount==1?'':'s'} Configured for the Database`} count={db.filtersCount} icon={<LuFilter />}/>)
            }


            return <Link key={db.id} className="database-row" data-name={db.name} href={"/database/"+db.id}>
                <div className="database-row-section name">{db.name}</div>
                <div className="database-row-section detail-icons">{icons}</div>
                <div className="database-row-section edit-icon">
                    <Link href={`/database/${db.id}`}><LuPencil /></Link>
                    <LuTrash2 onClick={(event) => {
                        setDatabaseToDelete(db)
                        setShowDeleteConfirmation(true)
                        event.preventDefault()
                    }}
                        className={"delete-icon"}
                    />
                </div>
            </Link>
        })


        let deletionModal = null
        if (showDeleteConfirmation) {
            deletionModal = <ConfirmationModal
                title="Delete Database"
                className="delete-database-modal"
                message="Are you sure you want to delete this Database?"
                onConfirm={deleteDatabase}
                onCancel={onCancelDelete}
            />
        }

        content = <>
            {deletionModal}
            <div className="database-list">{rows}</div>
        </>
    }



    const actionButton = <DefaultButton text="Define Database" onPress={() => {
        setRedirect(`/database/create`)
    }} />

    const description = "These are the definitions of your databases, in front of which you want to run your VeilStream proxies."

    return <FullWidthLayout
        title="Databases"
        mainContent={content}
        actionButton={actionButton}
        description={description}
    />
}

export default DatabaseList
